import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllJobApplication = createAsyncThunk(
  "JobApplication/FindAllJobApplication",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JobApplication/FindAllJobApplication`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching JobApplication:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
